import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfiguracionDialogoFormulario } from './utilidades/dialogo-formulario.static';
import { ValoresFormulario } from '../../formulario/utilidades/formulario.models';

@Component({
  selector: 'dialogos-formulario',
  templateUrl: './dialogo-formulario.component.html',
  styleUrls: ['./dialogo-formulario.component.scss'],
  standalone: false,
})
export class DialogoFormularioComponent {
  /* Formulario */
  protected valorFormulario: ValoresFormulario = {};
  protected validezFormulario: boolean = false;

  constructor(
    protected readonly dialogRef: MatDialogRef<DialogoFormularioComponent>,
    @Inject(MAT_DIALOG_DATA)
    protected readonly configuracion: ConfiguracionDialogoFormulario,
  ) {}
}
